import { render } from "./ZaloCallBack.vue?vue&type=template&id=52ebb9db"
import script from "./ZaloCallBack.vue?vue&type=script&lang=js"
export * from "./ZaloCallBack.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__